import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/rootReducer";
import { TokenGroup } from "@amzn/awsui-components-react";
import { setAttributeQuery } from "./searchSideBarConnector";
import { TokenGroupProps } from "@amzn/awsui-components-react/polaris/token-group/interfaces";

const BaselineIdTokenGroup = () => {
  const dispatch = useDispatch();
  const [items, setItems] = useState([] as TokenGroupProps.Item[]);
  const baselineId = useSelector(
    (state: RootState) => state.generateQuery.queryParameters.baselineId
  );

  useEffect(() => {
    const baselineIdTokenInfo = {
      label: "BaselineId",
      dismissLabel: "Remove Filter",
      description: baselineId.value as string,
    };
    setItems([baselineIdTokenInfo]);
  }, []);

  return (
    <TokenGroup
      onDismiss={({ detail: { itemIndex } }) => {
        setItems([]);
        dispatch(
          setAttributeQuery({
            attribute: "baselineId",
            queryState: {
              value: "",
            },
          })
        );
      }}
      items={items}
    />
  );
};

export default BaselineIdTokenGroup;
